<template>
  <div class="drama-home">
    <div class="full-width-banner">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="slide slide-1">
          <img src="../assets/images/banner1.jpg" alt="技术服务与智能硬件业务展示1" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-2">
          <img src="../assets/images/banner2.jpg" alt="物联网与电子产品业务展示2" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-3">
          <img src="../assets/images/banner3.jpg" alt="贸易代理与跨境物流业务展示3" class="banner-image" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="container">
      <section class="hero panel reveal">
        <div class="hero-copy">
          <p class="tag">技术服务与多元商贸综合服务商</p>
          <h1>以技术为底座，连接研发、产品与全球贸易</h1>
        <p class="desc">
          我们围绕技术服务、技术开发、技术咨询、技术交流、技术转让与技术推广，
          结合物联网、人工智能硬件、电子产品与多品类零售贸易，
          为客户提供从方案设计、产品交付到渠道流通的一体化服务。
        </p>
      </div>
      <div class="hero-data">
        <div class="data-card">
          <span class="number">技术服务</span>
          <span class="label">覆盖技术开发、技术咨询、技术交流、技术转让与技术推广全流程</span>
        </div>
        <div class="data-card">
          <span class="number">智能物联</span>
          <span class="label">物联网技术研发与技术服务，人工智能硬件销售协同落地</span>
        </div>
        <div class="data-card">
          <span class="number">全球贸易</span>
          <span class="label">货物进出口、技术进出口、进出口代理与国际货物运输代理</span>
        </div>
      </div>
    </section>

    <section class="genres reveal">
      <div class="section-head">
        <p>业务方向</p>
        <h2>覆盖技术研发与多品类经营的业务布局</h2>
      </div>
      <div class="genre-grid">
        <article class="genre-item">
          <h3>技术与网络服务</h3>
          <p>技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广、网络技术服务、信息技术咨询服务。</p>
        </article>
        <article class="genre-item">
          <h3>物联网与人工智能</h3>
          <p>物联网技术研发与技术服务，人工智能硬件销售，其他电子器件制造与电子产品销售。</p>
        </article>
        <article class="genre-item">
          <h3>商用密码产品</h3>
          <p>商用密码产品生产与销售，面向信息安全场景提供合规产品支持。</p>
        </article>
        <article class="genre-item">
          <h3>珠宝与工艺礼品</h3>
          <p>珠宝首饰制造与零售，工艺美术品及收藏品零售（象牙及其制品除外）、礼品花卉销售。</p>
        </article>
        <article class="genre-item">
          <h3>日用消费零售</h3>
          <p>日用百货、服装服饰、户外用品、灯具、五金产品、汽车零配件、计算机软硬件及辅助设备、通讯设备销售。</p>
        </article>
      </div>
    </section>

    <section class="lineup panel reveal">
      <div class="section-head">
        <p>服务能力</p>
        <h2>从研发交付到流通履约的完整链路</h2>
      </div>
      <div class="lineup-list">
        <div class="lineup-item">
          <p class="title">研发与技术交付</p>
          <p class="meta">以技术服务与技术开发为核心，提供方案咨询、技术交流和成果转让推广，支撑客户数字化升级。</p>
        </div>
        <div class="lineup-item">
          <p class="title">供应链与渠道</p>
          <p class="meta">国内贸易代理、互联网销售与进出口代理协同，连接生产端到消费端的高效流通网络。</p>
        </div>
        <div class="lineup-item">
          <p class="title">合规经营保障</p>
          <p class="meta">一般项目凭营业执照依法自主开展经营活动，道路货物运输（不含危险货物）等许可项目经批准后开展。</p>
        </div>
      </div>
    </section>

    <section class="cta reveal">
      <h2>技术驱动、品类多元、渠道通达的合作平台</h2>
      <p>支持技术研发合作、产品供应、渠道代理与跨境贸易联动，助力合作伙伴实现稳健增长。</p>
    </section>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
};
</script>

<style>
/* 覆盖父级设置的内容区内边距，让轮播图可以顶边 */
.site-main {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style scoped>
.drama-home {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding-bottom: 26px;
}

.full-width-banner {
  width: 100%;
  height: 80vh;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 20px;
}

.slide {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #11212b; /* 占位色 */
  position: relative;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  gap: 26px;
  padding: 0 24px;
}

.panel {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 20px;
  background: rgba(7, 14, 20, 0.72);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.3);
}

.hero {
  padding: 32px;
  display: grid;
  gap: 22px;
  grid-template-columns: 1.25fr 1fr;
}

.hero-copy {
  display: grid;
  align-content: start;
  gap: 8px;
}

.tag {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #ffb684;
}

h1 {
  margin: 14px 0;
  font-size: clamp(34px, 5vw, 56px);
  line-height: 1.08;
}

.desc {
  margin: 0;
  max-width: 620px;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.82);
}

.btn {
  border: 0;
  padding: 12px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.btn-solid {
  color: #fff;
  background: linear-gradient(110deg, #ff6f2c, #ff9259);
}

.hero-data {
  display: grid;
  gap: 12px;
  align-content: center;
}

.data-card {
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.number {
  display: block;
  font-size: 30px;
  font-weight: 800;
}

.label {
  color: rgba(236, 245, 250, 0.75);
  font-size: 13px;
}

.genres,
.lineup,
.cta {
  padding: 26px;
}

.section-head p {
  margin: 0;
  color: #ffb684;
  letter-spacing: 0.1em;
  font-size: 12px;
  text-transform: uppercase;
}

.section-head h2 {
  margin: 10px 0 18px;
  font-size: clamp(24px, 3vw, 34px);
}

.genre-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.genre-item {
  padding: 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.genre-item h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.genre-item p,
.lineup-item .meta,
.cta p {
  margin: 0;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.78);
}

.lineup-list {
  display: grid;
  gap: 12px;
}

.lineup-item {
  padding: 16px;
  border-radius: 14px;
  background: linear-gradient(120deg, rgba(255, 111, 44, 0.12), rgba(255, 255, 255, 0.06));
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.lineup-item .title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
}

.cta {
  border-radius: 20px;
  text-align: center;
  background: linear-gradient(120deg, rgba(255, 111, 44, 0.18), rgba(10, 40, 60, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.cta h2 {
  margin-top: 0;
}

.cta .btn {
  margin-top: 14px;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  animation: rise 0.7s ease forwards;
}

.reveal:nth-child(2) {
  animation-delay: 0.1s;
}

.reveal:nth-child(3) {
  animation-delay: 0.2s;
}

.reveal:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1060px) {
  .hero {
    grid-template-columns: 1fr;
  }

  .genre-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .hero,
  .genres,
  .lineup,
  .cta {
    padding: 22px;
  }

  .genre-grid {
    grid-template-columns: 1fr;
  }
}
</style>
